import styled from "styled-components";
import MarketHeaderBackground from "../../assets/images/background/marketHeaderBackground.png";
import MarketText from "../../assets/images/marketText.png";

const MarketHeader = (props) => {
    return (
        <StyledHeader>
            <img src={MarketText} alt="Market" />
        </StyledHeader>
    );
}
const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 420px;
  height: calc(12vh + var(--tg-safe-area-inset-top, 0px));
  min-height: 60px;
  padding-top: var(--tg-safe-area-inset-top);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${MarketHeaderBackground});
  z-index: 2;
  img{
    max-width:200px;
    margin-top: 52px;
  }
`
export default MarketHeader;